import { z } from 'zod';

const STATUSES = ['active', 'scheduled', 'expired'] as const;
const TYPES = ['amount_off_products', 'amount_off_order', 'bxgy', 'free_shipping'] as const;
const METHODS = ['code', 'automatic'] as const;
const SOURCES = ['discovr', 'other'] as const;

/** URL state of the Store discounts page. An invalid or absent value reads as "all". */
export const shopifyDiscountsSearchSchema = z.object({
  status: z.enum(STATUSES).optional().catch(undefined),
  type: z.enum(TYPES).optional().catch(undefined),
  method: z.enum(METHODS).optional().catch(undefined),
  source: z.enum(SOURCES).optional().catch(undefined),
  // The router JSON-parses search values, so `?q=2026` arrives as a number.
  q: z
    .union([z.string(), z.number()])
    .transform((v) => String(v).trim() || undefined)
    .optional()
    .catch(undefined),
});

export type ShopifyDiscountsSearch = z.infer<typeof shopifyDiscountsSearchSchema>;

export const hasActiveDiscountFilters = (f: ShopifyDiscountsSearch): boolean =>
  Boolean(f.status || f.type || f.method || f.source || f.q);
